/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind =
  {
    Approve: "approve",
    Burn: "burn",
    Mint: "mint",
    Transfer: "transfer",
  } as const;
export type ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind =
  ClosedEnum<
    typeof ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind
  >;

export type ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest =
  {
    ledgerCanisterId: string;
    id: string;
    offset?: number | undefined;
    limit?: number | undefined;
    maxTransactionIndex?: number | undefined;
    includeKind?:
      | Array<
        ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind
      >
      | undefined;
    /**
     * <I>Available values</I> : index, -index, kind, -kind, amount, -amount, timestamp, -timestamp
     */
    sortBy?: Array<string> | undefined;
  };

/** @internal */
export const ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$inboundSchema:
  z.ZodNativeEnum<
    typeof ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind
  > = z.nativeEnum(
    ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind,
  );

/** @internal */
export const ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$outboundSchema:
  z.ZodNativeEnum<
    typeof ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind
  > =
    ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$ {
  /** @deprecated use `ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$inboundSchema` instead. */
  export const inboundSchema =
    ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$inboundSchema;
  /** @deprecated use `ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$outboundSchema` instead. */
  export const outboundSchema =
    ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$outboundSchema;
}

/** @internal */
export const ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$inboundSchema:
  z.ZodType<
    ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    id: z.string(),
    offset: z.number().int().default(0),
    limit: z.number().int().default(20),
    max_transaction_index: z.number().int().optional(),
    include_kind: z.array(
      ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$inboundSchema,
    ).optional(),
    sort_by: z.array(z.string()).optional(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
      "max_transaction_index": "maxTransactionIndex",
      "include_kind": "includeKind",
      "sort_by": "sortBy",
    });
  });

/** @internal */
export type ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$Outbound =
  {
    ledger_canister_id: string;
    id: string;
    offset: number;
    limit: number;
    max_transaction_index?: number | undefined;
    include_kind?: Array<string> | undefined;
    sort_by?: Array<string> | undefined;
  };

/** @internal */
export const ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$outboundSchema:
  z.ZodType<
    ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$Outbound,
    z.ZodTypeDef,
    ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    id: z.string(),
    offset: z.number().int().default(0),
    limit: z.number().int().default(20),
    maxTransactionIndex: z.number().int().optional(),
    includeKind: z.array(
      ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$outboundSchema,
    ).optional(),
    sortBy: z.array(z.string()).optional(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
      maxTransactionIndex: "max_transaction_index",
      includeKind: "include_kind",
      sortBy: "sort_by",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$ {
  /** @deprecated use `ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$inboundSchema;
  /** @deprecated use `ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$outboundSchema;
  /** @deprecated use `ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$Outbound` instead. */
  export type Outbound =
    ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$Outbound;
}

export function listAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequestToJSON(
  listAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest:
    ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest,
): string {
  return JSON.stringify(
    ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$outboundSchema
      .parse(
        listAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest,
      ),
  );
}

export function listAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest' from JSON`,
  );
}
